export default "__VITE_ASSET__a7596181__"